import {
  Typenames,
  VxlSeparatedVerticalStackContainer,
  VxlSeparatedVerticalStackContainerChild,
  VxlSeparatedVerticalStackContainerChildResult,
} from '@varo/graphql-schema-types';
import { VXLGroupId, VXLNode } from 'shared/renderer/types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

import productStatusRowComponent from './productStatusRowComponent';
import { BorrowingPowerDependencies } from './types';

const separatedVerticalStackContainer = (
  component: VxlSeparatedVerticalStackContainer,
  { navigateForAction }: BorrowingPowerDependencies,
): VXLNode => {
  const { id, items } = component;

  const cells = items.flatMap(
    (item: VxlSeparatedVerticalStackContainerChild) => {
      // for DMGM we only use SdProductStatusRowComponent for now:
      const { onClick } = item;

      return item.content
        .map((child: VxlSeparatedVerticalStackContainerChildResult) => {
          if (child.__typename === Typenames.SDProductStatusRowComponent) {
            return productStatusRowComponent(child, () =>
              navigateForAction(onClick),
            ).props;
          }
          return null;
        })
        .filter(isNotNil);
    },
  );

  return {
    id,
    name: VXLGroupId.LIST_ITEM_GROUP,
    props: {
      items: cells,
    },
  };
};

export default separatedVerticalStackContainer;
